import RateReviewOutlined from '@mui/icons-material/RateReviewOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import type { NavItemProps } from '../CustomNavLink';
import { MOD_REVIEW_NAV_LABEL } from '../../../../constants/modification.strings';

// The licensor's way in to the AI-modification review queue. Drawn exactly as
// the Upload item is, with its own icon and an accessible name.
const Review = ({ ActiveComp }: NavItemProps) => (
  <Box
    sx={(theme) => ({
      alignItems: 'center',
      borderLeft: `1px solid ${theme.palette.divider}`,
      color: ActiveComp ? theme.palette.primary.main : 'inherit',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      padding: '1rem',
    })}
  >
    <IconButton size="small" color="inherit" aria-label={MOD_REVIEW_NAV_LABEL}>
      <RateReviewOutlined />
    </IconButton>
    {ActiveComp && <ActiveComp />}
  </Box>
);

export default Review;
